// extracted by mini-css-extract-plugin
export default {"aboutUsImage":"banner_aboutUsImage__ZdFI+","aboutUsImg":"banner_aboutUsImg__FCJIH"};